import axiosServices from "../utils/axios";

import { fetchSingleCsof } from "./sofDocuments";

export const fetchSof = async (
    page: number,
    pageSize: number,
    jobId?: string,
  ) => {
    const response = await axiosServices.get("/csof", {
      params: {
        page: page + 1,
        start: page * pageSize,
        limit: pageSize,
        ...(jobId && { job_id: jobId }),
      },
    });
    return (response.data);
  };

export const fetchSofEntries = async (csofId: string) => {
  const response = await fetchSingleCsof(csofId);
  return response.data?.csof_entries || [];
};

export const deleteCsof = async (csofId: string) => {
  const response = await axiosServices.delete(`/csof/${csofId}`);
  return response.data;
};
